/** @format */

module.exports = [
  {
    name: "otp-flow",
    title: "Internal OTP",
    description: "Flow including OTP",
    changes: true,
  },
];



// WEBPACK FOOTER //
// ./src/partners/config/variants.js